import React from "react";
import SEO from "./SEO";

const RedirectPage = () => {
    React.useEffect(() => {
      window.location.replace('https://oceanbeachbrands.myshopify.com')
    }, [])

    return (
      <SEO
        title="Shop Zeronimo | Ocean Beach Brands"
        description="Redirecting to the Ocean Beach Brands Shopify store."
        canonical="https://oceanbeachbrands.com/zeronimo"
        robots="noindex, follow"
      />
    );
  }

export default RedirectPage;
